<template>
  <BLayoutView
    :back-route="backRoute"
    :title="title"
    :skeleton="isLoadingAsyncData"
    :save-menu-list="null"
  >
    <template #form>
      <ComponentForm
        ref="form"
        :loading="isLoadingAsyncData"
        :skeleton="isLoadingAsyncData"
        is-create
        :is-edit="false"
        :is-view="false"
        class="my-4"
        @save="onSave"
        @delete="onDelete(single)"
      >
        <template #save-menu>
          <v-row dense class="mt-4">
            <v-spacer />
            <v-col cols="auto">
              <BFormButtons
                :loading="isLoading"
                :save-menu-list="saveMenuList"
                :skeleton="isLoadingAsyncData"
                :saveable="true"
                :editable="false"
                :deletable="false"
                @delete="onDelete(single)"
                @save-menu="onSave"
              />
            </v-col>
          </v-row>
        </template>
      </ComponentForm>
    </template>
  </BLayoutView>
</template>

<script>
import { MARKS_ROUTES as ROUTES } from './utils'

import BLayoutView from '@/components/layouts/BLayoutView.vue'
import BFormButtons from '@/components/common/BFormButtons.vue'
import ComponentForm from './components/MarksUploadForm.vue'

export default {
  name: 'MarksUploadView',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BLayoutView,
    BFormButtons,
    ComponentForm,
  },
  data: () => ({
    backRoute: { name: ROUTES.LIST },
    isLoadingAsyncData: false,
    isLoading: false,
  }),
  computed: {
    title() {
      const { which } = this.$route.query
      switch (which) {
        case 'MARKS':
          return 'Загрузить исходные результаты'
        case 'VEER':
          return 'Загрузить обработанные веера'
        case 'QUESTIONS':
          return 'Загрузить номера заданий или ключи'
        case 'TASKS_ORDER':
          return 'Загрузить порядок заданий'
        default:
          return 'Загрузить данные'
      }
    },
    saveMenuList() {
      const { which } = this.$route.query
      switch (which) {
        case 'MARKS':
          return [
            {
              name: 'update',
              label: 'Загрузить и обработать исходные результаты',
            },
          ]
        case 'VEER':
          return [
            {
              name: 'update',
              label: 'Загрузить и обработать обработанные веера',
            },
          ]
        case 'QUESTIONS':
          return [
            {
              name: 'update',
              label: 'Загрузить и обработать номера заданий или ключи',
            },
          ]
        case 'TASKS_ORDER':
          return [
            {
              name: 'update',
              label: 'Загрузить и обработать порядок заданий',
            },
          ]
        default:
          return [
            {
              name: 'update',
              label: 'Загрузить данные',
            },
          ]
      }
    },
  },
  methods: {
    async onSave() {
      try {
        this.isLoading = true
        await this.$refs.form.onSubmit()
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
